import Toast from 'vue-toastification';
import { ToastOptions } from 'vue-toastification/dist/types/src/types';
import 'vue-toastification/dist/index.css';
import './toast.css';

const toastOption: ToastOptions = {
  showCloseButtonOnHover: true,
  timeout: 3000,
  toastClassName: 'toast-container',
};

export { Toast, toastOption };
